import React from 'react';
import { BsWhatsapp } from 'react-icons/bs';
import { IoIosCloseCircle } from 'react-icons/io';
// import BlackFridayPopover from './BlackFridayPopover';
// import { Link } from 'react-router-dom';
// import blackFriday from '../assets/images/blackfriday.webp';

function Chat() {
  const [isVisible, setIsVisible] = React.useState(true);
  const whatsappMessage = encodeURIComponent(
    "Hey! I'm looking to build a website/app. Can we discuss my requirements?",
  );
  return (
    <div className="fixed bottom-[1rem] right-4 z-[100] flex flex-col gap-4">
      {/* --whatsapp--- */}
      <a target="_blank" href={`https://api.whatsapp.com/send/?phone=918427333204&text=${whatsappMessage}&type=phone_number&app_absent=0`} className="flex items-center gap-3 tooltip-container" rel="noreferrer">
        {/* --hover tooltip ---- */}
        <span className="tooltip bg-green-500 text-white px-3 py-2 rounded-full">Chat with Us</span>
        <div className="rounded-full text-white bg-green-500 p-3 text-[2rem] whatsapp">

          <BsWhatsapp />
        </div>
      </a>

      {isVisible && (
        <a
          href="https://thesynergyworks.com/christmas/"
          className="relative rounded-lg overflow-hidden cursor-pointer hover:scale-[1.02] transition-transform"
        >
          <button
            className="absolute z-10 top-1 right-2 hover:scale-110 transition-transform"
            onClick={(e) => {
              e.preventDefault();
              setIsVisible(false);
            }}
          >
            <IoIosCloseCircle className="h-8 w-8 text-gray-400 hover:text-gray-200" />
          </button>
          {/* <BlackFridayPopover /> */}
          {/* <ChirstmasPopover /> */}
        </a>
      )}
    </div>
  );
}

export default Chat;
